import { UserRelatedData } from '@y42/feature';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { DefaultFeatureChildListViewProps, FeatureListViewData } from '@y42/feature/shared/list-view';
import { PopoverFormOutput } from '@y42/feature/shared/popover-form';
import { ImpexState, ImpexStoreModel, ImpexUIModel, WithCredentials } from '@y42/impex';
import { ExportSettings, JobStatus } from '@y42/json-schema';
import type { ExportTriggerStoreModel, ExportTriggerUIModel } from '../export-trigger';
import { ExportCTypeModel, ExportTypeModel } from '../export-type';

/**
 * A representation of `settings.json` inside git
 */
export class ExportSettingsGitModel extends ExportSettings {
  constructor(model: ExportStoreModel) {
    super();
    Object.assign(this, model.settings);
  }
  /**
   * DO NOT MODIFY ANY PROPERTIES HERE.
   * TO LEARN HOW TO MODIFY CLASSES GENERATED FROM JSON-SCHEMA
   * TAKE A LOOK AT https://y42-com.slab.com/posts/working-with-json-schemas-1hz2gcvj
   */
}

export class ExportStoreModel
  extends Y42MetadataGitModel
  implements ImpexStoreModel<ExportSettingsGitModel>, WithCredentials
{
  constructor(model: ExportStoreModel) {
    super(model);
    this.$name = model.$name;
    this.$path = model.$path;
    this.$level = model.$level;
    this.$children = model.$children || [];
    this.settings = model.settings;
    this.secret = model.secret;
  }

  $name: string;
  $path: string;
  $level: number;
  $children: Array<ExportTriggerStoreModel['$path']>;
  settings: ExportSettingsGitModel;

  secret?: string;
}

export type ExportUIModel = ImpexUIModel<ExportTypeModel> &
  ExportStoreModel &
  Partial<UserRelatedData> & {
    typeIcon: NonNullable<ImpexUIModel['typeIcon']>;
    triggers: ExportTriggerUIModel[];
    isAuthorized?: boolean; // secret.enc
  };

export type ExportListViewData = FeatureListViewData<
  ExportUIModel & {
    rows: number;
    // needs to be number for ag-grid to be able to properly sort
    last_import_date?: number | null;
  },
  ExportTriggerUIModel & { status: JobStatus | null },
  DefaultFeatureChildListViewProps | 'status'
>;

export type ExportState = ImpexState<ExportStoreModel>;

export type CreateExportParams = PopoverFormOutput<ExportCTypeModel>;
